import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import ClipLoader from 'react-spinners/ClipLoader';
import { createUseStyles } from 'react-jss';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';


import Loader from '../components/Loader';
import Slider from '../components/Slider';
import { Twig, Business as BusinessType, Article, Product } from '../types';
import Cover from './Profile/Cover';
import TwigCard from '../components/TwigCard';
import { getTwigsByBusinessID } from '../services/TwigService';
import { useLoadMore } from '../lib/hooks';
import Text from '../components/Text';
import BusinessDetails from './Business/BusinessDetails';
import ProductCard from '../components/ProductCard';
import { Helmet } from 'react-helmet';
import { dateFormat, setMetaData } from '../services/helpers';
import { getArticlesById } from '../services/ApiService';
import ArticleCard from '../components/ArticleCard';
export interface BusinessProps {
  business: BusinessType;
}

const Business: React.FC<BusinessProps> = ({ business }) => {
  const classes = useStyles();
  const [twigs, setTwigs] = useState<Twig[]>([]);
  const [articles, setArticles] = useState<Article[]>([]);


  const [loadingTwigs, setLoadingTwigs] = useState<boolean>(true);
  const [loadingArticles, setLoadingArticles] = useState<boolean>(true);


  const [loadingMore, setLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);


  const [hasMore, setHasMore] = useState(true);
  const [doInfiniteScroll, setDoInfiniteScroll] = useState(false);
  const endReached = useLoadMore();

  useEffect(() => {
    (async () => {
      setLoadingTwigs(true);
      setLoadingArticles(true);
      try {
        const { twigs: response, pagination } = await getTwigsByBusinessID(
          business.id,
          1,
          10,
        );
        setTwigs(response);
        if (currentPage >= pagination.totalPages) {
          setHasMore(false);
        } else {
          setCurrentPage(currentPage + 1);
        }
        setDoInfiniteScroll(true);
        setLoadingTwigs(false);
        const articles  = await getArticlesById("business_id="+business.id);
        setArticles(articles);
        setLoadingArticles(false);
      } catch (e) { }
    })();
  }, []);
  // @Todo: refactor this and merge it with the above one
  useEffect(() => {
    if (!doInfiniteScroll || !hasMore || !endReached || loadingMore) return;
    (async () => {
      setLoadingMore(true);
      try {
        const { twigs: response, pagination } = await getTwigsByBusinessID(
          business.id,
          currentPage,
          10,
        );
        setTwigs([...twigs, ...response]);
        if (currentPage >= pagination.totalPages) {
          setHasMore(false);
        } else {
          setCurrentPage(currentPage + 1);
        }
      } catch (e) { }
      setLoadingMore(false);
    })();
  }, [
    doInfiniteScroll,
    hasMore,
    currentPage,
    endReached,
    loadingMore,
    twigs,
    business,
  ]);
  setMetaData({ "title": business.name + ' twigBIG | Social eCommerce Marketplace in Beauty and Fashion', 'image': business.logoUrl, 'description': business.description, "url": window.location.href })

  return (
    <>
      <Helmet>
        <title>{business.name}| twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
        <meta property="og:description" content={<h1>{business.name}</h1> + '| twigBIG | Social eCommerce Marketplace in Beauty and Fashion'} />

        {/* 
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="1671173566245525" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" /> 
        */}
        {/* <meta property="og:url" content={window.location.href} />

        <meta property="og:title" content={business.name + 'twigBIG | Social eCommerce Marketplace in Beauty and Fashion'} />

        <meta property="og:description" content={business.description ? business.description : business.name} />

        <meta property="og:image" content={business.logoUrl} /> */}

<script type="application/ld+json">
{
  `{  
  "@context": "https://schema.org",
  "@type": "OnlineStore",
  "name": "${business.name}",
  "description": "${business.description.replace(/"/g, "")}",
  "image": "${business.coverUrl}",
  "logo": "${business.logoUrl}",
  "telephone":"${business.phone}",
  
  "address":
    {
    "@type": "PostalAddress",
    "addressCountry": "${business.locations[0]?.address}",
    "addressLocality": "${business.locations[0]?.name}"
    },

"owns":{
  "@type": "ItemList",
  "url": "https://twigbig.com/${business.uniqueName}",
  "numberOfItems": "${business.products.length}",
  "itemListElement":[ ${business.products.map((product:Product)=>`
    {
      "@type": "Product",
      "name": "${product.name}",
      "url":"https://twigbig.com/${product.uniqueName}",
      "image": "${product.photo}",
      "description": "${product.description ? product.description.replace(/"/g, "") : ''}",
      "brand": "${product.brand?.name}"
      ${business.products[business.products.length-1].id ===product.id ? '}]' : '}' }
  `)}
},
  
  "review":${twigs.length ? `[${twigs.map((twig:Twig)=>`
  {
    "@type": "Review",
    "author": "${twig.user.name}",
    "datePublished": "${twig.createdAt}",
    "name": "${twig.uniqueName}",
    "reviewBody": "${twig.description}",
    "image":"${twig.mediaThumbUrl}",
    "interactionStatistic": [
      {
        "@type": "InteractionCounter",
        "interactionService": {
          "@type": "WebSite",
          "name": "twigBig",
          "url": "https://twigbig.com/"
        },
        "interactionType": "https://schema.org/LikeAction",
        "userInteractionCount": "${twig.favorites}"
      },
      {
        "@type": "InteractionCounter",
        "interactionService": {
          "@type": "SoftwareApplication",
          "name": "TwigBig",
          "url": "https://play.google.com/store/apps/details?id=com.twigbig.app"
        },
        "interactionType": "https://schema.org/LikeAction",
        "userInteractionCount": "${twig.favorites}"
      }
       ]
       ${twigs[twigs.length-1].id===twig.id ? '}]' : '}'}
  `)}
  ` : `[]`}
}`
}
</script>
      </Helmet>
      <Container className={classes.container}>
        <Row>
          <Col>
            <Cover src={business.coverUrl} />
          </Col>
        </Row>
        <Row>
          <Container fluid>
            <Row>
              <Col xs={12} lg={3}>
                <BusinessDetails business={business} />
              </Col>
              <Col xs={12} lg={9}>
                <div className={classes.productsBox}>
                  <div className={classes.productsHeader}>
                    <Text bold>Products</Text>
                    <Link className={classes.businessLink} to={"search?searchKey=&tab=products&&businessId="+business.id}>View All</Link>
                  </div>
                  <Slider>
                    {business.products.map((product) => (
                      <div
                        key={product.id}
                        className={classes.productSlideWrapper}
                      >
                        <ProductCard
                          className={classes.productSlide}
                          product={product}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
                {loadingArticles  ||  articles.length ? (
                  <div className={classes.articlesBox}>
                  
                  <Loader
                    className={classes.articlesLoader}
                    loading={loadingArticles}
                    center
                  >
                    {()=>(
                      <>
                      <div  className={classes.articlesHeader}>
                        <Text bold>Articles</Text>
                      </div>
                      <Slider>
                      {articles.map((article) => (
                        <div
                          key={article.id}
                          className={classes.articleSlideWrapper}
                        >
                          <ArticleCard
                           article={article}
                           />
                        </div>
                      ))}
                    </Slider>
                    </>
                    )}
                  </Loader>
                </div>
                ) : null}

                {twigs.length ? (
                  <div className={classes.twigsBox}>
                  <Text bold>twigs</Text>
                  <Loader
                    className={classes.twigsLoader}
                    loading={loadingTwigs}
                    center
                  >
                    {() => (
                      <>
                        <Masonry
                          breakpointCols={{
                            default: 2,
                            700: 1,
                          }}
                          columnClassName=""
                          className={classes.twigsWrapper}
                        >
                          {twigs.map((twig) => (
                            <div key={twig.id} className={classes.twigWrapper}>
                              <TwigCard twig={twig} />
                            </div>
                          ))}
                        </Masonry>
                        <div className={classes.loadingMoreBox}>
                          {loadingMore ? <ClipLoader color="#522583" /> : null}
                        </div>
                      </>
                    )}
                  </Loader>
                </div>
                ) : (null)}      

              </Col>
            </Row>
          </Container>
        </Row>
      </Container>
    </>
  );
};

const useStyles = createUseStyles({
  loader: {
    minHeight: '70vh',
  },
  container: {
    marginTop: '30px',
  },
  productsBox :{
    marginTop: '30px',
  },
  articlesBox:{
    marginTop: '30px',
  },
  productSlideWrapper: {
    paddingLeft: '10px',
    paddingRight: '10px',
    minHeight: '400px',
    display: 'flex !important',
    flexDirection: 'column',
    position: 'relative'
  },
  articleSlideWrapper:{
    paddingLeft: '10px',
    paddingRight: '10px',
    minHeight: '320px',
    display: 'flex !important',
    flexDirection: 'column',
    position: 'relative',
  },
  productSlide: {
    flex: 1,
  },
  twigsBox: {
    marginTop: '30px',
  },
  productsHeader:{
    display: 'flex',
    justifyContent: 'space-between',
  },
  articlesHeader:{
    display: 'flex',
    justifyContent: 'space-between',
  },
  businessLink : {
    color: '#522583',
    "&:hover": {
      color: "#522583",
      textDecoration: "underline",
  },
  },
  twigsLoader: {
    minHeight: '50vh',
  },
  articlesLoader:{
    minHeight: '50vh',
  },
  twigsWrapper: {
    display: 'flex',
    width: 'auto',
  },
  twigWrapper: {
    margin: '1rem',
    position: 'relative'
  },
  loadingMoreBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
});

export default Business;
